import { render, staticRenderFns } from "./SettingPrice.vue?vue&type=template&id=14feb591&scoped=true"
import script from "./SettingPrice.vue?vue&type=script&lang=js"
export * from "./SettingPrice.vue?vue&type=script&lang=js"
import style0 from "./SettingPrice.vue?vue&type=style&index=0&id=14feb591&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14feb591",
  null
  
)

export default component.exports